<template>
    <div>
        <input type="hidden" :value="ValidateDocumento">
        <div class="form-group row mt-4">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <label class="col-form-label"><em>Los campos marcados con un * son obligatorios</em></label>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                        <div class="form-group row">
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                <label for="TipoDocumento" class="form-label">Tipo de Documento*</label>
                                <select name="TipoDocumento" id="TipoDocumento" @change="HabilitarFacturas()"
                                    v-model="ObjDocumento.TipoDocumento" class="form-control form-select">
                                    <option value="">Seleccione una opción</option>
                                    <option value="I">Ingreso</option>
                                    <option value="T">Traslado</option>
                                </select>
                                <Cvalidation v-if="this.errorvalidacion.TipoDocumento"
                                    :Mensaje="'*' + errorvalidacion.TipoDocumento[0]" />
                            </div>
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                <label for="TipoTransporte" class="form-label">Tipo de Transporte*</label>
                                <select name="TipoTransporte" id="TipoTransporte" class="form-control form-select"
                                    v-model="ObjDocumento.TipoTransporte">
                                    <option value="">Seleccione una opción</option>
                                    <option value="Auto">Autotransporte</option>
                                </select>
                                <Cvalidation v-if="this.errorvalidacion.TipoTransporte"
                                    :Mensaje="'*' + errorvalidacion.TipoTransporte[0]" />
                            </div>
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                <label for="TranspInternac" class="form-label">Transporte Internacional*</label>
                                <select name="TranspInternac" id="TranspInternac" v-model="ObjDocumento.TranspInternac"
                                    class="form-control form-select" @change="ActivarInternacional()">
                                    <option value="">Seleccione una opción</option>
                                    <option value="SI">SI</option>
                                    <option value="NO">NO</option>
                                </select>
                                <Cvalidation v-if="this.errorvalidacion.TranspInternac"
                                    :Mensaje="'*' + errorvalidacion.TranspInternac[0]" />
                            </div>
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                <label for="TotalDistRec" class="form-label">Total de Distancia Recorrida*</label>
                                <input name="TotalDistRec" id="TotalDistRec" type="text" class="form-control"
                                    v-model="ObjDocumento.TotalDistRec" readonly>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                <label for="Folio" class="form-label">Folio Salida</label>
                                <input name="Folio" id="Folio" type="text" class="form-control" value="FOLIO12345"
                                    readonly>
                            </div>
                            <div v-show="ObjDocumento.TranspInternac === 'SI'" class="col-12 col-sm-12 col-md-3 col-lg-3">
                                <label for="EntradaSalidaMerc" class="form-label">Tipo de Mercancia</label>
                                <select name="EntradaSalidaMerc" id="EntradaSalidaMerc"
                                    v-model="ObjDocumento.EntradaSalidaMerc" class="form-control form-select"
                                    @change="SetEntSalMerc()">
                                    <option value="">Seleccione una opción</option>
                                    <option value="Entrada">Entrada</option>
                                    <option value="Salida">Salida</option>
                                </select>
                                <Cvalidation v-if="this.errorvalidacion.EntradaSalidaMerc"
                                    :Mensaje="'*' + errorvalidacion.EntradaSalidaMerc[0]" />
                            </div>
                            <div v-show="ObjDocumento.TranspInternac === 'SI'" class="col-12 col-sm-12 col-md-3 col-lg-3">
                                <label for="PaisOrigenDestino" class="form-label">País de Origen/Destino</label>
                                <select name="PaisOrigenDestino" id="PaisOrigenDestino" class="form-control form-select"
                                    v-model="ObjDocumento.PaisOrigenDestino">
                                    <option value="">Seleccione una opción</option>
                                    <option v-for="(elem, index) in DataInicial.pais" :key="index" :value="elem.IdPais">
                                        {{ elem.Clave }} - {{ elem.Nombre }}
                                    </option>
                                </select>
                                <Cvalidation v-if="this.errorvalidacion.PaisOrigenDestino"
                                    :Mensaje="'*' + errorvalidacion.PaisOrigenDestino[0]" />
                            </div>
                            <div v-show="ObjDocumento.TranspInternac === 'SI'" class="col-12 col-sm-12 col-md-3 col-lg-3">
                                <label for="ViaEntradaSalida" class="form-label">Via de Entrada/Salida</label>
                                <select name="ViaEntradaSalida" id="ViaEntradaSalida" class="form-control form-select"
                                    v-model="ObjDocumento.ViaEntradaSalida">
                                    <option value="">Seleccione una opción</option>
                                    <option v-for="viaES in DataInicial.clavetransporte" :value="viaES.Clave">
                                        {{ viaES.Clave }} - {{ viaES.Nombre }}
                                    </option>
                                </select>
                                <Cvalidation v-if="this.errorvalidacion.ViaEntradaSalida"
                                    :Mensaje="'*' + errorvalidacion.ViaEntradaSalida[0]" />
                            </div>
                        </div>

                    </div>
                </div>

                <div class="row mb-5">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <h5><b>Datos del cliente</b></h5>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="form-group row">
                            <div class="col-lg-5">
                                <label for="NameInstitucion" class="form-label">Cliente:</label>
                                <div class="input-group">
                                    <input name="NameInstitucion" id="NameInstitucion" type="text"
                                        class="form-control" v-model="ObjCliente.NameInstitucion" @input="AutocompCliente()"
                                        />
                                    <button type="button" @click="AutocompCliente()"
                                        class="btn btn-outline-primary boder-extend">
                                        <i :class="IconSearch"></i>
                                    </button>
                                </div>
                                <Cvalidation v-if="this.errorvalidacion.IdAgente"
                                :Mensaje="'*' + errorvalidacion.IdAgente[0]" />
                                <div class="position-relative">
                                    <ul class="busqueda list-group">
                                        <li v-for="(elem, index) in AutocompClienteList" :key="index"
                                            @click="SetDataCliente(elem.IdAgente)" class="bss list-group-item">
                                            <i class="fa fa-building me-2"></i> {{ elem.NombreComercial }} / {{ elem.RazonSocial }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <label for="ClienteDefault" class="me-1">Cliente Default</label>
                                <div class="form-check">
                                    <input name="ClienteDefault" id="ClienteDefault" class="form-check-input"
                                        type="checkbox" v-model="ClienteDefault" @change="SetClienteDefault()" />
                                    <span v-if="ClienteDefault">Sí</span>
                                    <span v-else>No</span>
                                </div>
                            </div>
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                            </div>
                        </div>
                        <br>
                        <div>
                            <div class="form-group row">
                                <div class="col-lg-6">
                                    <span class="has-float-label">
                                        <label for="NombreComercial" class="form-label">Empresa:</label>
                                        <input name="NombreComercial" id="NombreComercial" type="text" readonly
                                            class="form-control form-control-sm" v-model="ObjCliente.NombreComercial"
                                            required="true" />
                                    </span>
                                </div>

                                <div class="col-lg-4">
                                    <span class="has-float-label">
                                        <label for="ClRFC" class="form-label">RFC:</label>
                                        <input name="ClRFC" id="ClRFC" type="text" readonly
                                            class="form-control form-control-sm" v-model="ObjCliente.RFC" />
                                    </span>
                                </div>

                                <div class="col-lg-2">
                                    <span class="has-float-label">
                                        <label for="ClCP" class="form-label">Código Postal:</label>
                                        <input name="ClCP" id="ClCP" type="text" readonly
                                            class="form-control form-control-sm" v-model="ObjCliente.CP" required="true" />
                                    </span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-lg-4">
                                    <span class="has-float-label">
                                        <label for="ClEstado" class="form-label">Estado:</label>
                                        <input name="ClEstado" id="ClEstado" type="text" readonl
                                            class="form-control form-control-sm" v-model="ObjCliente.Estado" readonly/>
                                    </span>
                                </div>

                                <div class="col-lg-4">
                                    <span class="has-float-label">
                                        <label for="ClMunicipio" class="form-label">Ciudad/Municipio:</label>
                                        <input name="ClMunicipio" id="ClMunicipio" type="text" readonly
                                            class="form-control form-control-sm" v-model="ObjCliente.Municipio" />
                                    </span>
                                </div>

                                <div class="col-lg-4">
                                    <span class="has-float-label">
                                        <label for="ClColonia" class="form-label">Colonia:</label>
                                        <input name="ClColonia" id="ClColonia" type="text" readonly
                                            class="form-control form-control-sm" v-model="ObjCliente.Colonia" />
                                    </span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-lg-6">
                                    <label for="ClCalle" class="form-label">Calle:</label>
                                    <input name="ClCalle" id="ClCalle" type="text" readonly
                                        class="form-control form-control-sm" v-model="ObjCliente.Calle" />
                                </div>

                                <div class="col-lg-3">
                                    <label for="ClNumExt" class="form-label">No. Ext:</label>
                                    <input name="ClNumExt" id="ClNumExt" type="text" readonly
                                        class="form-control form-control-sm" v-model="ObjCliente.NumExt" />
                                </div>

                                <div class="col-lg-3">
                                    <label for="ClNumInt" class="form-label">No. Int:</label>
                                    <input name="ClNumInt" id="ClNumInt" type="text" readonly
                                        class="form-control form-control-sm" v-model="ObjCliente.NumInt" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="d-flex justify-content-between align-items-baseline">
                            <h5><b>Conceptos</b></h5>
                            <div class="form-group">
                                <button type="button" @click="AgregarConceptoVacio()" class="btn btn-info me-2"
                                    :disabled="!HabConcep">
                                    <i class="fa fa-plus-circle"></i> Nuevo Registro
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-show="HabConcep" class="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                        <div class="form-group row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th width="4%" v-if="ObjDocumento.TipoDocumento === 'I'">IVA <br> Ret.</th>
                                                <th width="4%" v-if="ObjDocumento.TipoDocumento === 'I'">IVA</th>
                                                <th width="10%">Servicio</th>
                                                <th width="10%">Unidad</th>
                                                <th width="10%" v-if="ObjDocumento.TipoDocumento === 'I'">Clave Imp.</th>
                                                <th width="16%" class="text-center">Descripción</th>
                                                <th width="8%" class="text-center">Cantidad</th>
                                                <th width="8%" class="text-center">Importe</th>
                                                <th width="8%" v-if="ObjDocumento.TipoDocumento === 'I'"
                                                    class="text-center">Importe Dto.
                                                </th>
                                                <th width="8%" v-if="ObjDocumento.TipoDocumento === 'I'"
                                                    class="text-center">IVA Ret.</th>
                                                <th width="8%" class="text-center">Total</th>
                                                <th width="6%" class="text-center">Eliminar</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in ListaConceptos" :key="index">
                                                <td v-if="ObjDocumento.TipoDocumento === 'I'">
                                                    <div class="form-check d-flex justify-content-center">
                                                        <input class="form-check-input" type="checkbox"
                                                            v-model="item.TieneIvaRet"
                                                            @change="HabilitarIvaRet(item); CalcularImporteUnitario(item); CalcularImportesTotal()" />
                                                    </div>
                                                </td>
                                                <td v-if="ObjDocumento.TipoDocumento === 'I'">
                                                    <div class="form-check d-flex justify-content-center">
                                                        <input class="form-check-input" type="checkbox"
                                                            v-model="item.TieneIva"
                                                            @change="CalcularImporteUnitario(item); CalcularImportesTotal()" />
                                                    </div>
                                                </td>
                                                <td class="text-center">
                                                    <select v-model="item.ClaveProdServ"
                                                        class="form-control form-select form-select-sm">
                                                        <option value="">Seleccionar</option>'
                                                        <option v-for="(elem, indexPS) in DataInicial.productoservicio"
                                                            :key="indexPS" :value="elem.Clave + '~' + elem.Nombre">
                                                            {{ elem.Clave }} - {{ elem.Nombre }}
                                                        </option>
                                                    </select>
                                                </td>
                                                <td class="text-center">
                                                    <select v-model="item.Unidad"
                                                        class="form-control form-select form-select-sm">
                                                        <option value="">Seleccionar</option>'
                                                        <option v-for="(elem, indexUM) in DataInicial.unidadmedida"
                                                            :key="indexUM" :value="elem.Clave + '~' + elem.Nombre">
                                                            {{ elem.Clave }} - {{ elem.Nombre }}
                                                        </option>
                                                    </select>
                                                </td>
                                                <td v-if="ObjDocumento.TipoDocumento === 'I'">
                                                    <select v-model="item.Codigo"
                                                        class="form-control form-select form-select-sm">
                                                        <option value="">Seleccionar</option>'
                                                        <option v-for="(elem, indexPS) in DataInicial.objimpuesto"
                                                            :key="indexPS" :value="elem.Clave + '~' + elem.Nombre">
                                                            {{ elem.Clave }} - {{ elem.Nombre }}
                                                        </option>
                                                    </select>
                                                </td>
                                                <td class="text-center">
                                                    <textarea v-model="item.Descripcion" class="form-control"
                                                        rows="2"></textarea>
                                                </td>
                                                <td class="text-center">
                                                    <input type="text" v-model="item.Cantidad"
                                                        @input="$onlyNums($event, item, 'Cantidad'); CalcularImporteUnitario(item); CalcularImportesTotal();"
                                                        class="form-control form-control-sm">
                                                </td>
                                                <td class="text-center">
                                                    <input type="text" v-model="item.Precio"
                                                        @input="$number_decimal($event, item, 'Precio'); CalcularImporteUnitario(item); CalcularImportesTotal();"
                                                        class="form-control form-control-sm">
                                                </td>
                                                <td v-if="ObjDocumento.TipoDocumento === 'I'" class="text-center">
                                                    <input type="text" v-model="item.ImpDescuento"
                                                        @input="$number_decimal($event, item, 'ImpDescuento'); CalcularImporteUnitario(item); CalcularImportesTotal();"
                                                        class="form-control form-control-sm">
                                                </td>
                                                <td v-if="ObjDocumento.TipoDocumento === 'I'" class="text-center">
                                                    <input type="text" v-model="item.ImporteRetIva"
                                                        @input="$number_decimal($event, item, 'ImporteRetIva'); CalcularImporteUnitario(item); CalcularImportesTotal();"
                                                        class="form-control form-control-sm" :readonly="!item.TieneIvaRet">
                                                </td>
                                                <td class="text-center">
                                                    <input type="text" v-model="item.Importe"
                                                        class="form-control form-control-sm" readonly>
                                                </td>
                                                <td class="text-center">
                                                    <button type="button" @click="EliminarConcepto(index)"
                                                        class="btn btn-danger btn-bus">
                                                        <i class="fa fa-trash"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                            <CSinRegistros :pContIF="ListaConceptos.length"
                                                :pColspan="ObjDocumento.TipoDocumento === 'I' ? 13 : 8">
                                            </CSinRegistros>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="HabFactura" class="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                        <div class="form-group row">
                            <div v-if="this.ObjDocumento.TipoDocumento === 'T'" class="col-12 col-lg-8">
                                <div class="form-group row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                        <div class="row">
                                            <div class="col-3">
                                                <label class="form-label">Forma pago</label>
                                            </div>
                                            <div class="col-9">
                                                <input type="text" class="form-control" v-model="ObjFactura.FormaPago"
                                                    readonly>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                        <div class="row">
                                            <div class="col-3">
                                                <label class="form-label">USO CFDI</label>
                                            </div>
                                            <div class="col-9">
                                                <input type="text" class="form-control" v-model="ObjFactura.UsoCfdi" readonly>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                        <div class="row">
                                            <div class="col-3">
                                                <label class="form-label">Moneda</label>
                                            </div>
                                            <div class="col-9">
                                                <input type="text" class="form-control" v-model="ObjFactura.Moneda"
                                                    readonly>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="this.ObjDocumento.TipoDocumento === 'I'" class="col-12 col-lg-8">
                                <div class="form-group row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                <div class="form-group row">
                                                    <div class="col-3">
                                                        <label for="CondicionesPago" class="form-label">Condición
                                                            Pago:</label>
                                                    </div>
                                                    <div class="col-9">
                                                        <select name="CondicionesPago" id="CondicionesPago"
                                                            v-model="ObjFactura.CondicionesPago"
                                                            class="form-control form-select">
                                                            <option value="">Selecciona una opción</option>
                                                            <option value="Contado">Contado</option>
                                                            <option value="Credito">Credito</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                <div class="form-group row">
                                                    <div class="col-3">
                                                        <label for="FormaPago" class="form-label">Forma Pago:</label>
                                                    </div>
                                                    <div class="col-9">
                                                        <select name="FormaPago" id="FormaPago" v-model="ObjFactura.FormaPago"
                                                            class="form-control form-select">
                                                            <option value="">Selecciona una opción</option>
                                                            <option v-for="(elem, idx) in DataInicial.formapago" :key="idx"
                                                                :value="elem.Clave+'~'+elem.Nombre">{{ elem.Clave+'~'+elem.Nombre }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                <div class="form-group row">
                                                    <div class="col-3">
                                                        <label for="Moneda" class="form-label">Moneda:</label>
                                                    </div>
                                                    <div class="col-9">
                                                        <select name="Moneda" id="Moneda" class="form-control form-select"
                                                            v-model="ObjFactura.Moneda">
                                                            <option value="">Selecciona una opción</option>
                                                            <option v-for="(elem, idx) in DataInicial.moneda" :key="idx"
                                                                :value="elem.Clave">{{ elem.Clave + ' - ' + elem.Nombre }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                <div class="form-group row">
                                                    <div class="col-3">
                                                        <label for="BancoCliente" class="form-label">Banco Cliente:</label>
                                                    </div>
                                                    <div class="col-9">
                                                        <select name="BancoCliente" id="BancoCliente"
                                                            class="form-control form-select" v-model="ObjFactura.IdBanco">
                                                            <option value="">Selecciona una opción</option>
                                                            <option v-for="(elem, idx) in DataInicial.bancoscliente"
                                                                :key="idx" :value="elem.IdBanco">{{ elem.Nombre }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                <div class="form-group row">
                                                    <div class="col-3">
                                                        <label for="TipoRelacion" class="form-label">Tipo Relación:</label>
                                                    </div>
                                                    <div class="col-9">
                                                        <select name="TipoRelacion" id="TipoRelacion"
                                                            v-model="ObjFactura.TipoRelacion" class="form-control form-select">
                                                            <option value="">Selecciona una opción</option>
                                                            <option v-for="(elem, idx) in DataInicial.tiporelacion"
                                                                :key="idx" :value="elem.Clave">{{ elem.Clave+' - '+elem.Nombre}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                <div class="form-group row">
                                                    <div class="col-3">
                                                        <label for="MetodoPago" class="form-label">Método Pago:</label>
                                                    </div>
                                                    <div class="col-9">
                                                        <select name="MetodoPago" id="MetodoPago"
                                                            class="form-control form-select" v-model="ObjFactura.MetodoPago">
                                                            <option value="">Selecciona una opción</option>
                                                            <option v-for="(elem, idx) in DataInicial.metodopago" :key="idx"
                                                                :value="elem.Clave">{{ elem.Clave + ' - ' + elem.Nombre }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                <div class="form-group row">
                                                    <div class="col-3">
                                                        <label for="UsoCfdi" class="form-label">Uso CFDI:</label>
                                                    </div>
                                                    <div class="col-9">
                                                        <select name="UsoCfdi" id="UsoCfdi" class="form-control form-select"
                                                            v-model="ObjFactura.UsoCfdi">
                                                            <option value="">Selecciona una opción</option>
                                                            <option v-for="(elem, idx) in DataInicial.usocfdi" :key="idx"
                                                                :value="elem.Clave">{{ elem.Clave + ' - ' + elem.Nombre }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                <div class="form-group row">
                                                    <div class="col-3">
                                                        <label for="TipoCambio" class="form-label">Tipo Cambio:</label>
                                                    </div>
                                                    <div class="col-9">
                                                        <input type="text" name="TipoCambio" id="TipoCambio" @input="$number_decimal($event, ObjFactura, 'TipoCambio');"
                                                            class="form-control" v-model="ObjFactura.TipoCambio">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                <div class="form-group row">
                                                    <div class="col-3">
                                                        <label for="NumCtaPago" class="form-label">No. Cta. Cliente:</label>
                                                    </div>
                                                    <div class="col-9">
                                                        <input type="text" name="NumCtaPago" id="NumCtaPago"
                                                            class="form-control" v-model="ObjFactura.NumCtaPago">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                <div class="form-group row">
                                    <div class="col-lg-5">
                                        <label>Sub total</label>
                                    </div>
                                    <div class="col-lg-7">
                                        <input type="text" class="form-control input-sm" v-model="ObjFactura.SubTotal"
                                            placeholder="SubTotal" readonly="true">
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div class="col-lg-5">
                                        <label>Descuento</label>
                                    </div>
                                    <div class="col-lg-7">
                                        <input type="text" class="form-control input-sm" v-model="ObjFactura.Descuento"
                                            placeholder="Descuento" readonly="true">
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div class="col-lg-5">
                                        <label>I.V.A</label>
                                    </div>
                                    <div class="col-lg-7">
                                        <input type="text" class="form-control input-sm" v-model="ObjFactura.Iva"
                                            placeholder="Iva" readonly="true">
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div class="col-lg-5">
                                        <label>Iva (Retención)</label>
                                    </div>
                                    <div class="col-lg-7">
                                        <input type="text" class="form-control input-sm" v-model="ObjFactura.IvaRetencion"
                                            placeholder="IvaRetencion" readonly="true">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-lg-5">
                                        <label>Total</label>
                                    </div>
                                    <div class="col-lg-7">
                                        <input type="text" class="form-control input-sm" v-model="ObjFactura.Total"
                                            readonly="true" placeholder="Total">
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-12 col-md-9 col-lg-12 col-xl-12" v-if="ObjDocumento.TipoDocumento==='I'">
                                    <div class="form-group row">
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-3">
                                            <h5 class=""><b>Documentos Relacionados</b></h5>
                                        </div>
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-3">
                                            <button class="btn btn-primary" @click="AbrirModalFacutras()" :disabled="!ObjFactura.TipoRelacion">
                                                <i class="fa fa-search"></i> Buscar
                                            </button>
                                            <button v-if="ObjFactura.ListaRelacionados.length>0" class="btn btn-danger ms-2" @click="BorrarTodosDocRelacionado()">
                                                <i class="fa fa-trash"></i> Borrar todos
                                            </button>
                                        </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <div class="row">
                                    <div v-for="(item, idx) in ObjFactura.ListaRelacionados" class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                <input class="form-control mb-2" type="text" readonly v-model="item.TipoRelacionCFDI">
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                <div class="input-group">
                                                    <input class="form-control" type="text" v-model="item.IdDocumentoRelacionado">
                                                    <button type="button" class="btn btn-outline-danger mb-0" @click="BorrarDocRelacionado(idx)"><i class="fa fa-trash"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                                
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" v-show="false">
                                <div class="form-group row">
                                    <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
                                        <label for="DocRelacionado" class="fomr-label">
                                            Doc. Relacionado
                                        </label>
                                        <input name="DocRelacionado" id="DocRelacionado" type="text" class="form-control" readonly>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <CModal v-if="false" :pConfigModal="ConfigModaConcepto" :poBtnSave="oBtnSave2">
            <!-- <template slot="Form">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right mb-2">
                    <button @click="AgregarTodosCon" class="btn btn-info" :disabled="DisableAgrTodos"> <i
                            class="fa fa-plus-circle"></i> Agregar todos</button>
                </div>

                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tab-comen ">
                    <CLoader :pConfigLoad="ConfigLoadRC">
                        <template slot="BodyFormLoad">
                            <table class="table table-line table-striped">
                                <thead>
                                    <tr>
                                        <th>Cantidad</th>
                                        <th>Importe</th>
                                        <th>Total</th>
                                        <th>Descripción</th>
                                        <th>Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="concepto in ArrGetConceptos">
                                        <td width="8%">
                                            <input type="text" class="form-control" :value="concepto.Cantidad" readonly>
                                        </td>
                                        <td width="20%">
                                            <input type="text" class="form-control" :value="concepto.Precio" readonly>
                                        </td>
                                        <td width="20%">
                                            <input type="text" class="form-control" :value="concepto.Importe" readonly>
                                        </td>
                                        <td class="text-center">
                                            <textarea class="form-control" rows="4" v-model="concepto.Descripcion"
                                                readonly></textarea>
                                        </td>
                                        <td class="text-center" width="10%">
                                            <button v-if="concepto.AddButton" @click="AgregarConcepto(concepto)"
                                                type="button" v-b-tooltip.hover.Top title="Agregar concepto"
                                                class="btn btn-info btn-bus" :disabled="!concepto.AddButton">
                                                <i class="fa fa-plus-circle fa-2x" aria-hidden="true"></i>
                                            </button>
                                        </td>
                                    </tr>
                                    <CSinRegistro :pContIF="ArrGetConceptos.length" :pColspan="5"></CSinRegistro>
                                </tbody>
                            </table>
                        </template>
                    </CLoader>
                </div>
            </template> -->
        </CModal>
        <CModal :pConfigModal="ConfigModalFactura" :poBtnSave="oBtnSave2">
            <template slot="Form">
                <CpFacturaList :poBtnSave="oBtnSave2">
                    
                </CpFacturaList>
            </template>
        </CModal>
    </div>
</template>
<script>

const EmitEjecuta = 'seccionDocumento';
import Configs from '@/helpers/VarConfig.js';
const SPINNER = 'spinner-border spinner-border-sm';
const MAGNIFIER = 'fa fa-search';
import CpFacturaList from '@/views/modulos/finanzas/cartaporte/documento/FacturasCartaporte';

export default {
    name: 'FormDocumento',
    props: ['pObjDocumento', 'DataInicial', 'pObjCliente', 'pListaConceptos','pListaRelacionados', 'pObjFactura', 'poBtnSave', 'pErrorvalidacion'],
    components: {CpFacturaList},
    data() {
        return {
            ConfigLoad: {
                ShowLoader: true,
                ClassLoad: true,
            },
            ConfigLoadRC: {
                ShowLoader: false,
                ClassLoad: true,
            },
            ObjDocumento: {
                IdCotizacion: 0,
                TipoDocumento: '',
                TipoTransporte: '',
                TranspInternac: '',
                Folio: '',
                TotalDistRec: '',
                EntradaSalidaMerc: '', // Tipo de mercancia
                PaisOrigenDestino: '',
                ViaEntradaSalida: '',
            },
            ObjCliente: {
                IdCliente: '',
                IdAgente: '',             // Cliente
                // NameInstitucion: '',     // Cliente
                RazonCliente: '',        // Razon cliente
                NombreComercial: '',     // Empresa
                CP: '',
                RFC: '',
                Estado: '',
                Ciudad: '',
                Municipio: '',
                Calle: '',
                NumExt: '',
                NumInt: '',
            },
            ClienteDefault: false,
            ConfigModaConcepto: {
                ModalTitle: "Conceptos de la cotización",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ShowFooter: false,
                ModalSize: 'lg'
            },
            ConfigModalFactura: {
                ModalTitle: "Agregar nueva información",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ShowFooter: false,
                ModalSize: 'xl'
            },
            ObjFactura: {
                IdFactura: '',
                UsoCfdi: '',
                FormaPago: '',
                Moneda: '',
                SubTotal: '',
                Descuento: '',
                Iva: '',
                IvaRetencion: '',
                PcteIva: 0.16,
                Total: '',
                //En caso de ser de Ingreso
                MetodoPago: '',
                CondicionesPago: '',
                NumCtaPago: '',
                IdBanco: '',
                TipoCambio: '',
                TipoRelacion: '',
                IdDocRel: '',
                ListaRelacionados:[],
            },
            oBtnSave2: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            ListaConceptos: [],
            ArrGetConceptos: [],
            // HELPERS
            IconSearch: MAGNIFIER,
            AutocompClienteList:[],
            TimeOutSearch: null,
            HabConcep: false,
            HabFactura: false,
            DisableAgrTodos: true,
            segurity: {},
            masks: { input: 'YYYY-MM-DD' }, // quitar sino lleva fecha 
            errorvalidacion: [],
            Emit: '',
        }
    },
    methods:
    {
        // Habilita la seccion de facturas.
        HabilitarFacturas() {
            let TipoDocumento = this.ObjDocumento.TipoDocumento;
            this.ListaConceptos = [];
            if (TipoDocumento === 'T' || TipoDocumento === 'I') {
                this.ObjFactura.SubTotal = parseFloat(0).toFixed(2);
                this.ObjFactura.Descuento = parseFloat(0).toFixed(2);
                this.ObjFactura.Iva = parseFloat(0).toFixed(2);
                this.ObjFactura.IvaRetencion = parseFloat(0).toFixed(2);
                this.ObjFactura.Total = parseFloat(0).toFixed(2);
                if (TipoDocumento === 'T') {
                    this.ObjFactura.FormaPago = '99~POR DEFINIR';
                    this.ObjFactura.Moneda = 'XXX';
                    this.ObjFactura.UsoCfdi = 'P01~Por definir';
                } else {
                    this.ObjFactura.CondicionesPago = '';
                    this.ObjFactura.FormaPago = '';
                    this.ObjFactura.Moneda = '';
                    this.ObjFactura.IdBanco = '';
                    this.ObjFactura.TipoRelacion = '';
                    this.ObjFactura.MetodoPago = '';
                    this.ObjFactura.UsoCfdi = '';
                    this.ObjFactura.TipoCambio = '';
                    this.ObjFactura.NumCtaPago = '';
                }
                this.HabFactura = true;
            } else {
                this.HabFactura = false;
            }
            this.HabilitarConceptos();
        },
        // Habilita la seccion de conceptos.
        HabilitarConceptos() {
            let TipoDocumento = this.ObjDocumento.TipoDocumento;
            if (TipoDocumento === 'T' || TipoDocumento === 'I') {
                this.HabConcep = true;
            } else {
                this.HabConcep = false;
            }
        },
        // Desbloque el campo de IVA Ret.
        HabilitarIvaRet(item) {
            if (!item.TieneIvaRet) {
                item.ImporteRetIva = parseFloat(0).toFixed(2)
            }
        },
        AbrirModalFacutras(){
            if(this.ObjCliente.IdAgente||this.ClienteDefault){
                this.bus.$emit('NewModal_' + EmitEjecuta,this.ObjCliente.IdAgente, this.ObjFactura.ListaRelacionados);
            } else {
                this.$toast.warning('Se debe seleccionar un cliente primero')
            }
        },
        // Recupera la lista de conceptos.
        async BuscarConceptos() {
            this.bus.$emit('NewModal_' + EmitEjecuta);
            this.ArrGetConceptos = [];
            this.DisableAgrTodos = true;
            this.ConfigLoadRC.ShowLoader = true;
            await this.$http.get("factlistcotz/get.api", {
                params: { IdCotizacion: this.ObjDocumento.IdCotizacion }
            }).then((res) => {
                const ResLista = res.data.row;

                // Compara los arrays de res y los que estan en la tabla, agrega el helper AddButton para mostrar el 
                // boton para añadirlo a la tabla de conceptos.
                this.ArrGetConceptos = ResLista.map(elem => {
                    let isAdded = this.ListaConceptos.some(elem2 => {
                        return (elem.IdDetalleCotizacionServicioCalibracion === elem2.IdDetalle);
                    })
                    let obj = {
                        IdDetalleCotizacion: elem.IdDetalleCotizacionServicioCalibracion,
                        ClaveProdServ: '',
                        Unidad: '',
                        Descripcion: elem.Descripcion,
                        Cantidad: elem.Cantidad,
                        Precio: elem.Precio,
                        Importe: elem.Importe,
                        // En caso de ser Ingreso
                        ImpDescuento: 0,
                        ImporteRetIva: 0,
                        Codigo: '',
                        Isr: '0.00',
                        Iva: 0,
                        // Helpers
                        AddButton: !isAdded,
                    };

                    return obj;
                })
                this.UpdtBtnAgregarTodos();
            }).finally(() => {
                this.ConfigLoadRC.ShowLoader = false;
            });
        },
        // Agrega un concepto vacio en la tabla de conceptos.
        AgregarConceptoVacio() {
            let concepto = {
                IdDetalleCotizacion: '',
                ClaveProdServ: '',
                Unidad: '',
                Descripcion: '',
                Cantidad: '',
                Precio: '',
                Importe: parseFloat(0).toFixed(2),
                //Helpers
                TieneIva: true,
                TieneIvaRet: false,
            }
            // En caso de ser Ingreso
            if (this.ObjDocumento.TipoDocumento === 'I') {
                concepto = {
                    ...concepto,
                    ImpDescuento: 0,
                    ImporteRetIva: parseFloat(0).toFixed(2),
                    Codigo: '',
                    Isr:  parseFloat(0).toFixed(2),
                    Iva:  parseFloat(0).toFixed(2),
                }
            }
            this.ListaConceptos.push(concepto);
        },
        // Calcula el Total para cada fila de conceptos.
        CalcularImporteUnitario(item) {
            let total = 0.00;
            let cant = parseInt(item.Cantidad);
            if(item.ImpDescuento > 100){
                this.$toast.warning('El decuento no puede ser superior a 100');
                item.ImpDescuento = 100;
            }
            if (!isNaN(cant)) {
                let descuento = item.ImpDescuento ? (1 - item.ImpDescuento * .01) : 1;
                if (descuento < 0) {
                    descuento = 0;
                }
                total = parseFloat(item.Precio * item.Cantidad * descuento);
            }
            if (item.TieneIva) {
                item.Iva = total * 0.16;
                item.Iva = item.Iva.toString();
            } else {
                item.Iva = 0;
            }
            if (item.TieneIvaRet) {
                item.Isr = item.ImporteRetIva * total;
                item.Isr = item.Isr.toString();
            }
            item.Importe = total.toFixed(2);
            this.CalcularImportesTotal();
        },
        // Cacula los variables de los conceptos
        CalcularImportesTotal() {
            if (this.ObjDocumento.TipoDocumento === 'T') {
                return true;
            } else {
                let subTotal = 0;
                let descuento = 0;
                let iva = 0;
                let ImporteRetIva = 0;
                let total = 0;

                this.ListaConceptos.forEach(elem => {
                    let descConcepto = elem.ImpDescuento ? (1 - elem.ImpDescuento * .01) : 1;
                    let subTotalConcepto = parseFloat(elem.Precio * elem.Cantidad * descConcepto);
                    subTotal += subTotalConcepto;
                    if (elem.ImpDescuento) {
                        descuento += parseFloat((elem.ImpDescuento * .01) * elem.Cantidad * elem.Precio);
                    }
                    if (elem.TieneIva) {
                        iva += parseFloat(subTotalConcepto * 0.16);
                    }
                    elem
                    if (elem.TieneIvaRet) {
                        ImporteRetIva += parseFloat(subTotalConcepto * elem.ImporteRetIva);
                    }
                })
                total = subTotal + iva + ImporteRetIva;
                this.ObjFactura.SubTotal = parseFloat(subTotal).toFixed(2);
                this.ObjFactura.Descuento = parseFloat(descuento).toFixed(2);;
                this.ObjFactura.Iva = parseFloat(iva).toFixed(2);;
                this.ObjFactura.IvaRetencion = parseFloat(ImporteRetIva).toFixed(2);;
                this.ObjFactura.PcteIva = 0.16;
                this.ObjFactura.Total = parseFloat(total).toFixed(2);
            }
        },
        EliminarConcepto(index) {
            this.$swal(Configs.configEliminar).then((result) => {
                if (result.value) {
                    this.ListaConceptos.splice(index, 1);
                }
                this.CalcularImportesTotal();
            });
        },
        AgregarDocRelacionado(UUID){
            let nombreRel = this.DataInicial.tiporelacion.find(elem => elem.Clave == this.ObjFactura.TipoRelacion).Nombre;
            let tipoRel = this.ObjFactura.TipoRelacion+'~'+nombreRel;
            let newDocRel = {
                TipoRelacionCFDI:tipoRel,
                IdDocumentoRelacionado:UUID,
            }
            this.ObjFactura.ListaRelacionados.push(newDocRel);
            this.$toast.success('Documento agregado correctamente');
        },
        BorrarDocRelacionado(index){
            this.ObjFactura.ListaRelacionados.splice(index,1)
        },
        BorrarTodosDocRelacionado(){
            this.ObjFactura.ListaRelacionados = [];
        },
        // Activa o desactiva campos para transporte internacional. 
        ActivarInternacional() {
            if (this.ObjDocumento.TranspInternac !== 'SI') {
                this.ObjDocumento.EntradaSalidaMerc = '';
                this.ObjDocumento.PaisOrigenDestino = '';
                this.ObjDocumento.ViaEntradaSalida = '';
            }
            // Habilita o desahbilita pedimentos y/o fraccion en Mercancias
            this.bus.$emit('HabilitarFraccion', this.ObjDocumento.TranspInternac);
            this.bus.$emit('HabilitarPedimentos', this.ObjDocumento.EntradaSalidaMerc);
        },
        // Habilita pedimentos en la sección Mercancais si es entrada
        SetEntSalMerc() {
            this.bus.$emit('HabilitarPedimentos', this.ObjDocumento.EntradaSalidaMerc);
        },
        AutocompCliente(){
            clearTimeout(this.TimeOutSearch);
            this.TimeOutSearch = setTimeout(() => {
                const MINLENGTH = 2;
                const KEYWORD = this.ObjCliente.NameInstitucion ? this.ObjCliente.NameInstitucion : '';
                if (KEYWORD.length > MINLENGTH) {
                    this.IconSearch = SPINNER;
                    this.$http.get('agentes/',{
                        params: {
                        TxtBusqueda: KEYWORD,
                    }
                    })
                    .then((res) => {
                        this.AutocompClienteList = res.data.data.data;
                    }).finally(() => {
                        this.IconSearch = MAGNIFIER;
                    })
                } else {
                    this.AutocompClienteList = [];
                }
            }, 750);
        },
        // Rellena los campos de la sección cliente segun Razon Cliente (IdRazonCliente)..
        SetDataCliente(IdAgente) {
            if (IdAgente) {
                this.ClienteDefault = false;
                // this.ObjCliente.Empresa = res.data.data.RazonSocial;
                // this.ObjCliente.RFC = res.data.data.Rfc;
                let agenteSeleccionado = this.AutocompClienteList.find(elem => elem.IdAgente === IdAgente);
                if(agenteSeleccionado){
                    Object.assign(this.ObjCliente, agenteSeleccionado);
                } else {
                    this.$http.get('agentes/'+IdAgente
                    ).then((res)=> {
                        agenteSeleccionado = res.data.data;
                        Object.assign(this.ObjCliente, agenteSeleccionado);
                    }).catch(err => console.error(err))
                }
                this.AutocompClienteList = [];
            } else {
                this.ObjFactura.ListaRelacionados = [];
                this.LimpiarCliente();
            }
        },
        // Pone los campos genericos para Cliente por Default en el cliente.
        SetClienteDefault() {
            this.LimpiarCliente();
            if (this.ClienteDefault) {
                this.ObjCliente.IdCliente = 0;
                this.ObjCliente.RFC = 'XAXX010101000';
                this.ObjCliente.NombreComercial = 'Cliente por default';
            }
        },
        // Habilita o deshabilita el botón 'Agregar todos' del modal de conceptos.
        UpdtBtnAgregarTodos() {
            this.DisableAgrTodos = this.ArrGetConceptos.every(elem =>
                this.ListaConceptos.some(elem2 => elem.IdDetalleCotizacion === elem2.IdDetalleCotizacion)
            )
        },
        // Añade todos los conceptos que no esten agregados de la lista del modal a la tabla.
        AgregarTodosCon() {
            this.ArrGetConceptos.forEach(elem => {
                const isAdded = this.ListaConceptos.some(elem2 => elem2.IdDetalleCotizacion === elem.IdDetalleCotizacion);
                if (!isAdded) {
                    elem.AddButton = false;
                    this.ListaConceptos.push(elem);
                }
            })
            this.$toast.success('Conceptos Agregados');
            this.bus.$emit('AgregarConMerc', [...this.ArrGetConceptos], true);
            this.UpdtBtnAgregarTodos();
        },
        // Agrega el concepto recibido a la tabla de conceptos.
        AgregarConcepto(item) {
            item.AddButton = false;
            this.ListaConceptos.push(item);
            this.UpdtBtnAgregarTodos();
            this.$toast.success('Concepto Agregado');
            this.bus.$emit('AgregarConMerc', [item], false);
        },
        Limpiar() {
            Object.keys(this.ObjDocumento).forEach(propiedad => {
                this.ObjDocumento[propiedad] = '';
            });
            Object.keys(this.ObjCliente).forEach(propiedad => {
                this.ObjCliente[propiedad] = '';
            });
            this.ClienteDefault = false;
            //ObjFactura
            this.ObjFactura.FormaPago = '';
            this.ObjFactura.Moneda = '';
            this.ObjFactura.UsoCfdi = '';
            this.ObjFactura.SubTotal = parseFloat(0).toFixed(2);
            this.ObjFactura.Descuento = parseFloat(0).toFixed(2);
            this.ObjFactura.Iva = parseFloat(0).toFixed(2);
            this.ObjFactura.IvaRetencion = parseFloat(0).toFixed(2);
            this.ObjFactura.Total = parseFloat(0).toFixed(2);

            this.errorvalidacion = [];
        },
        // Vacía todos los campos del cliente excepto NameInstitucion (empresa).
        LimpiarCliente() {
            Object.keys(this.ObjCliente).forEach(propiedad => {
                if (propiedad !== 'NameInstitucion') {
                    this.ObjCliente[propiedad] = '';
                }
            });
        },
        // Setea la data recuperada cuando es un recovery de la cartaporte.
        SetearDataRecov() {
            // console.log('Inicio Data')
            // console.log(this.pListaConceptos);
            // console.log(this.pObjDocumento);
            // console.log(this.pObjFactura);
            // console.log(this.pObjCliente);
            // console.log('Fin Data')
            
            if (this.pObjDocumento != undefined) {
                Object.assign(this.ObjDocumento, this.pObjDocumento);
                this.ObjDocumento.EntradaSalidaMerc = this.ObjDocumento.EntradaSalidaMerc ?? '';
                this.ObjDocumento.PaisOrigenDestino = this.ObjDocumento.PaisOrigenDestino ?? '';
                this.ObjDocumento.ViaEntradaSalida = this.ObjDocumento.ViaEntradaSalida ?? '';
            }
            this.HabilitarFacturas();

            if (this.pObjFactura != undefined) {
                Object.keys(this.pObjFactura).forEach(elem => {
                    if (Object.hasOwn(this.ObjFactura, elem) && this.pObjFactura[elem] != '') {
                        this.ObjFactura[elem] = this.pObjFactura[elem];
                    }
                })
                this.ObjFactura.IdBanco = this.pObjFactura.Banco;
                this.ObjFactura.SubTotal = this.pObjFactura.Subtotal;
                this.ObjFactura.IvaRetencion = this.pObjFactura.Isr;
                if (this.ObjDocumento.TipoDocumento == 'I'){
                    let formaPago = this.DataInicial.formapago.find(elem => elem.Clave== this.pObjFactura.ClavePago);
                    this.ObjFactura.FormaPago = formaPago.Clave+'~'+formaPago.Nombre;
                } else {
                    this.ObjFactura.FormaPago = this.pObjFactura.ClavePago+'~'+this.ObjFactura.FormaPago.toUpperCase();
                }
                this.ObjCliente.IdAgente = this.pObjFactura.IdCliente;
                this.ObjCliente.IdCliente = this.pObjFactura.IdCliente;
                if (this.pObjFactura.RfcCliente == 'XAXX010101000' ) {
                    this.ClienteDefault = true;
                    this.SetClienteDefault();
                } else if (this.ObjCliente.IdCliente > 0) {
                    this.SetDataCliente(this.ObjCliente.IdCliente);
                }
                
            }
            if (this.pListaRelacionados.length >=1) {
                this.ObjFactura.ListaRelacionados = this.pListaRelacionados;
            }
            // if (this.pObjCliente != undefined) {
            //     Object.assign(this.ObjCliente, this.pObjCliente);
            // }

            if (this.pListaConceptos.length >= 1) {
                if (this.ObjDocumento.TipoDocumento == 'I'){
                    this.pListaConceptos.forEach(concepto => {
                        let newConcepto = {
                            TieneIva: concepto.Iva>0 ? true : false,
                            TieneIvaRet: concepto.Isr>0 ? true : false,
                        }
                        Object.assign(newConcepto,concepto);
                        let codigo = this.DataInicial.objimpuesto.find(elem => elem.Clave+'~'+elem.Nombre.toUpperCase()==newConcepto.Codigo);
                        newConcepto.Codigo = codigo.Clave+'~'+codigo.Nombre;
                        // let str = newConcepto.Codigo;
                        // str = str.split('~')
                        // newConcepto.Codigo = str[0] + '~' + str[1].charAt(0).toUpperCase() + str[1].slice(1).toLowerCase();                        
                        newConcepto.ImpDescuento = concepto.Descuento ? concepto.Descuento : 0;
                        this.ListaConceptos.push(newConcepto);
                    })
                } else if (this.ObjDocumento.TipoDocumento == 'T'){
                    this.ListaConceptos = this.pListaConceptos;
                }
                // this.ListaConceptos.forEach(elem => {
                //     elem['IdDetalle'] = elem.IdDetalleCotizacion;
                //     delete elem.IdDetalleCotizacion;
                // })

            }
            this.bus.$emit('HabilitarFraccion', this.ObjDocumento.TranspInternac);
            this.bus.$emit('HabilitarPedimentos', this.ObjDocumento.EntradaSalidaMerc);
        }
    },
    created() {
        this.ConfigLoad.ShowLoader = true;
        this.bus.$off('AgregarFactura_'+EmitEjecuta);
    },
    mounted() {
        this.Limpiar();
        if (this.pObjDocumento.IdCotizacion != '') {
            this.ObjDocumento.IdCotizacion = this.pObjDocumento.IdCotizacion;
        }
        else {
            this.ConfigLoad.ShowLoader = false;
        }
        this.bus.$on('AgregarFactura_'+EmitEjecuta,(UUID)=>{
            this.AgregarDocRelacionado(UUID);
        })
        this.SetearDataRecov();

    },
    computed: {
        ValidateDocumento() {
            if (this.pObjDocumento != undefined) {
                this.ObjDocumento.TotalDistRec = this.pObjDocumento.TotalDistRec;
            }
            if (this.pErrorvalidacion != undefined) {
                this.errorvalidacion = this.pErrorvalidacion;
            }
        }
    },
}
</script>
<style>
</style>